// import React, { useState } from 'react';
// import { NavLink, useNavigate } from 'react-router-dom';

// function AdminMenu({ onLogout }) {
//     const [showMenu, setShowMenu] = useState(false);
//     const navigate = useNavigate();

//     const handleLogout = () => {
//         localStorage.removeItem('token');
//         localStorage.removeItem('user');
//         if (onLogout) onLogout();
//         setShowMenu(false);
//         navigate('/login');
//     };

//     return (
//         <>
//             {/* Mobile Navbar with toggle button */}
//             <nav className="navbar navbar-light bg-light d-md-none shadow-sm fixed-top">
//                 <div className="container-fluid">
//                     <span className="navbar-brand mb-0 h5">Admin Panel</span>
//                     <button
//                         className="btn btn-outline-primary"
//                         type="button"
//                         onClick={() => setShowMenu(!showMenu)}
//                         aria-controls="adminSidebar"
//                         aria-expanded={showMenu}
//                         aria-label="Toggle navigation"
//                     >
//                         ☰
//                     </button>
//                 </div>
//             </nav>

//             {/* Sidebar */}
//             <div
//                 className={`bg-white border-end position-fixed top-0 start-0 vh-100 overflow-auto shadow-sm
//           ${showMenu ? 'd-block' : 'd-none'} d-md-block`}
//                 id="adminSidebar"
//                 style={{ width: '220px', zIndex: 1050, paddingTop: '56px' }} // padding top to avoid fixed navbar on mobile
//             >
//                 <div className="p-3 d-flex flex-column justify-content-between" style={{ height: '100%' }}>
//                     <div>
//                         <h5 className="text-primary text-center mb-4 d-none d-md-block">Admin Panel</h5>
//                         <ul className="nav nav-pills flex-column">
//                             <li className="nav-item">
//                                 <NavLink
//                                     to="/admin/results"
//                                     className={({ isActive }) =>
//                                         `nav-link ${isActive ? 'active' : 'text-dark'}`
//                                     }
//                                     onClick={() => setShowMenu(false)}
//                                 >
//                                     🏁 Results
//                                 </NavLink>
//                             </li>
//                             <li className="nav-item">
//                                 <NavLink
//                                     to="/admin/categories"
//                                     className={({ isActive }) =>
//                                         `nav-link ${isActive ? 'active' : 'text-dark'}`
//                                     }
//                                     onClick={() => setShowMenu(false)}
//                                 >
//                                     🗂 Series
//                                 </NavLink>
//                             </li>
//                             <li className="nav-item">
//                                 <NavLink
//                                     to="/admin/users"
//                                     className={({ isActive }) =>
//                                         `nav-link ${isActive ? 'active' : 'text-dark'}`
//                                     }
//                                     onClick={() => setShowMenu(false)}
//                                 >
//                                     👤 Users
//                                 </NavLink>
//                             </li>
//                             <li className="nav-item">
//                                 <NavLink
//                                     to="/admin/setting"
//                                     className={({ isActive }) =>
//                                         `nav-link ${isActive ? 'active' : 'text-dark'}`
//                                     }
//                                     onClick={() => setShowMenu(false)}
//                                 >
//                                     ⚙️ Slot Settings
//                                 </NavLink>
//                             </li>

//                         </ul>
//                     </div>

//                     {/* Logout button at bottom */}
//                     <div className="mt-auto">
                        
//                         <button
//                             className="btn btn-outline-warning w-100 mb-2"
//                             onClick={() => navigate('/admin/admin_password_reset')} // Adjust route path if needed
//                             type="button"
//                         >
//                             🔑 Reset Password
//                         </button>
//                         <button
//                             className="btn btn-outline-danger w-100"
//                             onClick={handleLogout}
//                             type="button"
//                         >
//                             🔒 Logout
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             {/* Spacer to offset content on md and up */}
//             <div className="d-none d-md-block" style={{ width: '220px' }}></div>
//         </>
//     );
// }

// export default AdminMenu;
import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

function AdminMenu({ onLogout }) {
    const [isNavCollapsed, setIsNavCollapsed] = useState(true);
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        if (onLogout) onLogout();
        setIsNavCollapsed(true);
        navigate('/login');
    };

    const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);
    const closeMenu = () => setIsNavCollapsed(true);

    return (
        <>
            {/* Top Navigation Bar - Primary Theme */}
            {/* navbar-dark: makes text white. bg-primary: makes background blue */}
            <nav className="navbar navbar-expand-lg navbar-dark bg-primary fixed-top shadow">
                <div className="container-fluid">
                    
                    {/* Brand Name */}
                    <span className="navbar-brand fw-bold">
                        Admin Panel
                    </span>

                    {/* Mobile Toggler Button */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        onClick={handleNavCollapse}
                        aria-controls="adminNavbar"
                        aria-expanded={!isNavCollapsed}
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    {/* Collapsible Content */}
                    <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`} id="adminNavbar">
                        
                        {/* Navigation Links */}
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <NavLink
                                    to="/admin/results"
                                    className="nav-link"
                                    onClick={closeMenu}
                                >
                                    🏁 Results
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink
                                    to="/admin/categories"
                                    className="nav-link"
                                    onClick={closeMenu}
                                >
                                    🗂 Series
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink
                                    to="/admin/users"
                                    className="nav-link"
                                    onClick={closeMenu}
                                >
                                    👤 Users
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink
                                    to="/admin/setting"
                                    className="nav-link"
                                    onClick={closeMenu}
                                >
                                    ⚙️ Slot Settings
                                </NavLink>
                            </li>
                        </ul>

                        {/* Action Buttons */}
                        {/* Changed to 'light' variants for better contrast on blue background */}
                        <div className="d-flex flex-column flex-lg-row gap-2 mt-2 mt-lg-0">
                            <button
                                className="btn btn-light btn-sm text-primary fw-bold"
                                onClick={() => {
                                    navigate('/admin/admin_password_reset');
                                    closeMenu();
                                }}
                                type="button"
                            >
                                🔑 Reset Password
                            </button>
                            <button
                                className="btn btn-outline-light btn-sm"
                                onClick={handleLogout}
                                type="button"
                            >
                                🔒 Logout
                            </button>
                        </div>
                    </div>
                </div>
            </nav>

            {/* SPACER: Pushes page content down so it is not hidden behind the fixed navbar */}
            <div style={{ height: '70px' }}></div>
        </>
    );
}

export default AdminMenu;